export const AuthError = {
  UserNotConfirmedException: "UserNotConfirmedException",
  UsernameExistsException: "UsernameExistsException",
  UserNotFoundException: "UserNotFoundException",
  UserAlreadyAuthenticatedException: "UserAlreadyAuthenticatedException",
  NotAuthorizedException: "NotAuthorizedException",
  CodeMismatchException: "CodeMismatchException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  LimitExceededException: "LimitExceededException",
  NetworkError: "NetworkError",
  UserLambdaValidationException: "UserLambdaValidationException",
} as const

export type AuthError = (typeof AuthError)[keyof typeof AuthError]

export const UserErrorExceptions = {
  EntityNotFoundException: "com.betomorrow.server.spring.exceptions.NotFoundException",
  ConflictException: "com.betomorrow.server.spring.exceptions.ConflictException",
} as const

export type UserErrorException = (typeof UserErrorExceptions)[keyof typeof UserErrorExceptions]

export const UserErrorCodes = {
  UserNotExistsCode: "USER_NOT_EXISTS",
  UsernameAlreadyExists: "USERNAME_ALREADY_EXISTS",
} as const

export type UserErrorCodes = (typeof UserErrorCodes)[keyof typeof UserErrorCodes]

/**
 * Cognito sign-in steps that require routing the user to a dedicated screen instead of
 * completing the login. Raised by useLogin as a {@link LoginNextStepError} so the caller can
 * branch on a typed `step` rather than matching error message strings.
 */
export const LoginNextStep = {
  ConfirmSignUp: "CONFIRM_SIGN_UP",
  ResetPassword: "RESET_PASSWORD",
} as const

export type LoginNextStep = (typeof LoginNextStep)[keyof typeof LoginNextStep]

export class LoginNextStepError extends Error {
  readonly step: LoginNextStep

  constructor(step: LoginNextStep) {
    super(`Login requires an additional step: ${step}`)
    this.name = "LoginNextStepError"
    this.step = step
  }
}
